// Operations specific to this Shopify theme.

// DOM

export const waitForSelector = async (selector) => {
  const el = document.querySelector(selector);
  if (el) return el;
  await new Promise((res) => window.requestAnimationFrame(() => res()));
  return waitForSelector(selector);
};

export const waitForDom = () =>
  new Promise((res) => {
    if (["interactive", "complete"].includes(document.readyState)) return res();
    document.addEventListener("DOMContentLoaded", () => res(), { once: true });
  });

// Device

const isAppleDevice = () =>
  navigator.platform && /^iPad|^iPhone|^iPod|^Mac.*/.test(navigator.platform);

// Obfuscation

export const deobfuscateEmail = (obId, obTxt, opt = { changeLabel: false }) => {
  const email = obTxt.split("@").reverse().join("").replace("^", "@");
  const el = document.querySelector(`[data-obfuscation-id="${obId}"]`);
  el.href = `mailto:${email}`;
  if (opt.changeLabel) el.innerText = email;
  delete el.dataset.obfuscationId;
};

export const deobfuscatePhone = (obId, obTxt, opt = { changeLabel: false }) => {
  const phone = obTxt.split("@").reverse().join("").replace(/z/g, "0");
  const el = document.querySelector(`[data-obfuscation-id="${obId}"]`);
  el.href = `tel:${phone}`;
  if (opt.changeLabel) el.innerText = phone;
  delete el.dataset.obfuscationId;
};

// Images

const buildResponsiveImageOnLoadHandler = (imgEl) => () => {
  imgEl.parentNode.removeChild(imgEl.parentNode.children[0]);
  imgEl.classList.remove("absolute");
};

export const upgradeResponsiveImages = (selector) => {
  const imgEls = Array.from(document.querySelectorAll(selector));
  imgEls.forEach((el) => {
    if (el.getAttribute("loading") !== "lazy") return;
    const handler = buildResponsiveImageOnLoadHandler(el);
    el.addEventListener("load", handler, { once: true });
    if (!el.complete) return;
    el.removeEventListener("load", handler);
    handler();
  });
};

// Maps

export const upgradeMapLinks = (selector) => {
  if (!isAppleDevice()) return;
  const linkEls = Array.from(document.querySelectorAll(selector));
  linkEls.forEach((el) => {
    if (el.dataset.appleMaps) el.href = el.dataset.appleMaps;
  });
};
